/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ReportB2WOrW2BTransferCustomerProblemeMutationVariables = {
    transactionId: string;
    comments: string;
};
export type ReportB2WOrW2BTransferCustomerProblemeMutationResponse = {
    readonly reportB2wOrW2bCustomerProblem: {
        readonly result: string | null;
    } | null;
};
export type ReportB2WOrW2BTransferCustomerProblemeMutation = {
    readonly response: ReportB2WOrW2BTransferCustomerProblemeMutationResponse;
    readonly variables: ReportB2WOrW2BTransferCustomerProblemeMutationVariables;
};



/*
mutation ReportB2WOrW2BTransferCustomerProblemeMutation(
  $transactionId: ID!
  $comments: String!
) {
  reportB2wOrW2bCustomerProblem(comments: $comments, transactionId: $transactionId) {
    result
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "comments"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "transactionId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "comments",
        "variableName": "comments"
      },
      {
        "kind": "Variable",
        "name": "transactionId",
        "variableName": "transactionId"
      }
    ],
    "concreteType": "ReportB2WOrW2BCustomerProblem",
    "kind": "LinkedField",
    "name": "reportB2wOrW2bCustomerProblem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportB2WOrW2BTransferCustomerProblemeMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReportB2WOrW2BTransferCustomerProblemeMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "2c67dfc744ebce7162239f395069f48f",
    "id": null,
    "metadata": {},
    "name": "ReportB2WOrW2BTransferCustomerProblemeMutation",
    "operationKind": "mutation",
    "text": "mutation ReportB2WOrW2BTransferCustomerProblemeMutation(\n  $transactionId: ID!\n  $comments: String!\n) {\n  reportB2wOrW2bCustomerProblem(comments: $comments, transactionId: $transactionId) {\n    result\n  }\n}\n"
  }
};
})();
(node as any).hash = '98d342058c49bed5807e518e261516d9';
export default node;
